import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ApplicationService } from "../../services/application.service";
import { MenuItem } from "../../models/menu-item";
import { ActivatedRoute } from "@angular/router";
import { forEach } from "lodash";
import { Store } from "@ngrx/store";
import { NavState } from "../../../store/navigation/navigation.reducer";
import * as NavActions from '../../../store/navigation/navigation.action';


@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})

/*
  NOTE: THIS COMPONENT ONLY RENDERS THE SIDEBAR BASED ON THE NAVIGATION SERVICE DATA.
        TO CHANGE ANY NAVIGATION RELATED LOGIC, USE THE NAVIGATION SERVICE.
*/
export class SidebarComponent implements OnInit {
  openMenu = "../../../assets/svg/menu-icon/menu.png";
  iconMenu = "../../../assets/svg/menu-icon/open.png";

  isOpenSidebar: boolean = false;
  stepMenu: MenuItem[] = [];
  selectedPage: MenuItem | null = null;
  isBlinking: boolean = false;
  itemsToBlink: MenuItem[] = [];
  constructor(
    public dialog: MatDialog,
    public route: ActivatedRoute,
    private app: ApplicationService,
    private store: Store<NavState>
  ) { }

  ngOnInit() {
    this.app.selectedStep.subscribe(step => {
      if (step && step.menuScope[0]) {
        this.itemsToBlink = [];
        this.startBlinking();
        const menus = [...step.menuScope[0].children]
        this.stepMenu = menus;

        const index = this.stepMenu.findIndex(item => item.route === '/videoTutorial');

        if (index !== -1) {
          const elementsAfterTutorial = this.stepMenu.slice(index + 1);

          elementsAfterTutorial.forEach(element => {
            if (element.route !== '/customerDataUploader') {
              this.itemsToBlink.push(element);
            }
          });
        } else {
          console.log("element with route '/videoTutorial' not found.");
        }

        this.startBlinking();
      }
      console.log("Selected step:", this.selectedPage);
      this.store.dispatch(NavActions.touchpoint({ item: step?.name ?? '' }));
    })
    this.app.selectedPage.subscribe(page => {
      this.selectedPage = page
      console.log("Selected Page:", this.selectedPage);
      const name = page?.name ?? '';
      const idItem = page?.idItem ?? '';
      const record = idItem.indexOf("#") >= -1 ? name : idItem;
      this.store.dispatch(NavActions.leftMenu({ item: record == "Home" ? "Journey" : record }));
    })
  }

  openSidebar() {
    this.isOpenSidebar = !this.isOpenSidebar;
  }

  closeSidebar() {
    this.isOpenSidebar = false;
  }

  selectMenuItem(item: MenuItem) {
    if (item.idItem.toLowerCase() === "dashboard") {
      this.app.demoSubject.next(true);
      this.app.afterSalesSubject.next(true);
      this.app.salesSubject.next(true);
      this.app.productSubject.next(true);
    }
    this.closeSidebar()
    this.app.selectPage(item)
  }

  openHelpDesk() {
    window.open('https://roarfocusplatform.com/form-cnh-nar/');
  }

  startBlinking() {
    //TEMPORARY deactivation of Blinking Mechanism. Uncomment to make it works
    this.isBlinking = true;
    setTimeout(() => {
      this.isBlinking = false;
    }, 5000); // Stop blinking after 5 seconds
    //this.isBlinking = false;
  }

  shouldBlink(iconName: string): boolean {
    const flatItems = this.flattenItemsToBlink(this.itemsToBlink);
    return flatItems.includes(iconName);
  }

  flattenItemsToBlink(items: any): string[] {
    let iconNames: string[] = [];

    Object.values(items).forEach((item) => {
      if (Array.isArray(item)) {
        // If item is an array, iterates through the array and picks up iconName
        item.forEach((subItem) => {
          if (typeof subItem === 'object' && subItem !== null && 'iconName' in subItem) {
            iconNames.push(subItem.iconName);
          }
        });
      } else if (typeof item === 'object' && item !== null) {
        // If item is an object, check if it has iconName and if it is not null or contains other objects
        if ('iconName' in item && item.iconName !== 'null') {
          iconNames.push((item as { iconName: string }).iconName);
        } else {
          // If it has no iconName, it recursively explores the object
          iconNames = iconNames.concat(this.flattenItemsToBlink(item));
        }
      }
    });

    return iconNames;
  }

}
